import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonym chat forside`,
    languageButtonLabel: `Sprog`,
    languageModalTitle: `Vælg et sprog`,
    languageModalCloseLabel: `Luk sprogmenuen`,
  },
  languageOptions: {
    'en-US': {
      label: `Engelsk (USA)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engelsk (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engelsk (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engelsk (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugisisk (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portugisisk (Brasilien)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tysk (Tyskland)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Tysk (Østrig)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Tysk (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spansk (Spanien)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Fransk (Frankrig)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiensk (Italien)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederlandsk (Nederlandene)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polsk (Polen)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Svensk (Sverige)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk (Danmark)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finsk (Finland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk (Norge)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandsk (Island)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japansk (Japan)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreansk (Sydkorea)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Kinesisk (Kina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesisk (SAR Hongkong)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamesisk (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai (Thailand)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesisk (Indonesien)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (Indien)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (Indien)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (Indien)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persisk (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigeriansk pidgin (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russisk (Rusland)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabisk (Saudi-Arabien)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabisk (De Forenede Arabiske Emirater)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabisk (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية (Marokko)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Tyrkisk (Tyrkiet)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Vælg et sprog`,
    closeLabel: `Luk sprogmenuen`,
  },
  languageHint: (ctx) => `Hop mellem ${ctx.localesCount}+ sprog uden at oprette konto.`,
  readPagePrompt: ({languageLabel}) => `Læs denne side på ${languageLabel}.`,
};
